import React from "react";
import { Box, Drawer } from "@mui/material";
import ProjectHelpHeader from "../ProjectHelpHeader";
import ProjectHelpBodyUser from "./ProjectHelpBodyUser";
import ActionButton from "../../ActionButton";
import { GRAY_COLOR, PROJECT_COLOR } from "../../../../constants/colors";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

/**
 * ユーザー(モバイル)向けサジェストウィジェット本文
 */
export default function ProjectHelpWidgetUserMobile({
  open,
  setOpen,
  step,
  formState,
  isDesktop,
}) {
  const handleToggle = () => setOpen((v) => !v);
  const handleClose = () => setOpen(false);

  return (
    <>
      {/* 閉じてる時：右下固定の呼び出しボタン */}
      {!open && (
        <Box
          sx={{
            position: "fixed",
            zIndex: 1100,
            right: { xs: 0, sm: 24 },
            bottom: {
              xs: "env(safe-area-inset-bottom)",
              sm: 24,
            },
            width: { xs: "100%", sm: "auto" },
            p: { xs: 1.5, sm: 0 },
            backgroundColor: {
              xs: "rgba(0, 0, 0, 0.5)",
              sm: "transparent",
            },
            boxShadow: {
              xs: "0 -4px 12px rgba(0,0,0,0.12)",
              sm: "none",
            },
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <ActionButton
              label="企業側によく聞かれるポイント"
              icon={<AssignmentTurnedInIcon sx={{ color: "#fff" }} />}
              onClick={handleToggle}
              sx={{
                color: PROJECT_COLOR,
                backgroundColor: "#fff",
                border: `2px solid ${PROJECT_COLOR}`,
                "&:hover": {
                  backgroundColor: "#fff",
                  opacity: 0.9,
                },
              }}
              iconSx={{
                backgroundColor: PROJECT_COLOR,
                width: 28,
                height: 28,
                left: 8,
              }}
            />
          </Box>
        </Box>
      )}

      {/* 開いてる時：下から出る */}
      <Drawer
        anchor="bottom"
        open={open}
        onClose={handleClose}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 18,
            borderTopRightRadius: 18,
            overflow: "hidden",
            maxHeight: "85vh",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {/* ハンドル */}
        <Box sx={{ display: "flex", justifyContent: "center", pt: 1 }}>
          <Box
            sx={{
              width: 48,
              height: 5,
              borderRadius: 999,
              bgcolor: GRAY_COLOR,
            }}
          />
        </Box>

        {/* ヘッダー */}
        <ProjectHelpHeader
          open={open}
          dragging={false}
          onToggle={handleToggle}
          isDesktop={isDesktop}
        />

        {/* 本文 */}
        <Box sx={{ flex: 1, overflowY: "auto", px: 2, pb: 2 }}>
          <ProjectHelpBodyUser step={step} formState={formState} />
        </Box>
      </Drawer>
    </>
  );
}
